module.exports = __webpack_public_path__ + "img/coupon-3.1132921a.png";